<script lang="ts">
  import LoadingSpinner from './Icons/LoadingSpinner.svelte';
  
  let isAffiliatePopupOpen = $state(false);
  let popupContainer;
  
  function toggleAffiliatePopup() {
    isAffiliatePopupOpen = !isAffiliatePopupOpen;
  }
  
  $effect(() => {
    if (isAffiliatePopupOpen && popupContainer) {
      const existingScript = document.querySelector('script[src="https://refgrow.com/js/page.js"]');
      if (existingScript) {
        existingScript.remove();
      }
      
      const script = document.createElement('script');
      script.src = 'https://refgrow.com/js/page.js';
      script.async = true;
      document.body.appendChild(script);
    }
  });

  const footerItems = {
    blocks: [
      {
        title: "Product",
        links: [
          { name: "Pricing & Plans", href: "/pricing" },
          { name: "Giveaway Directory", href: "/giveaways" },
          { name: "(Free) Random Name Picker", href: "/random-name-picker" },
          {
            name: "Instagram Comment Picker",
            href: "/instagram-comment-picker",
          },
          {
            name: "Sweepstakes Rules Generator",
            href: "/sweepstakes-rules-generator",
          },
        ],
      },
      // {
      //   title: "Company",
      //   links: [
      //     { name: "About us", href: "/about" },
      //     // { name: "Blog", href: "/blog" },
      //     // { name: "Careers", href: "#" },
      //   ],
      // },
      {
        title: "Resources",
        links: [
          { name: "Blog", href: "/blog" },
          {
            name: "130 Best Giveaway Prize Ideas",
            href: "/blog/best-giveaway-prize-ideas",
          },
          {
            name: "Affiliate Program",
            href: "#",
            isAffiliateLink: true
          },
          { name: "Privacy Policy", href: "/privacy" },
          { name: "Terms of use", href: "/terms" },
        ],
      },
      {
        title: "Contact Us",
        links: [
          { name: "hi@promoamp.com", href: "mailto:hi@promoamp.com" },
          // { name: "support@promoamp.com", href: "mailto:support@promoamp.com" },
          // { name: "Status", href: "#" },
        ],
      },
      // {
      //   title: "Social",
      //   links: [
      //     { name: "Twitter", href: "#", ariaLabel: "Twitter" },
      //     { name: "Medium", href: "#", ariaLabel: "Medium" },
      //     { name: "Github", href: "#", ariaLabel: "Github" },
      //   ],
      // },
    ],
    branding: {
      logo: {
        src: "/logo.svg",
        alt: "Promo Amp Home Page",
        width: 160,
        href: "/",
      },
      byline:
        "Grow your business with effortless giveaways. Launch, manage, and track competitions with ease with Promo Amp. 🚀",
      copyright: `&copy; ${new Date().getFullYear()} PromoAmp.com - All rights reserved.`,
    },
  }
</script>

<footer>
  <div class="max-w-6xl mx-auto px-4 sm:px-6">
    <!-- Top area: Blocks -->
    <div class="grid sm:grid-cols-12 gap-10 py-8 md:py-12">
      <!-- Branding block -->
      <div class="sm:col-span-12 lg:col-span-4 space-y-6">
        <div>
          <!-- Logo -->
          <a
            class="inline-flex"
            href={footerItems.branding.logo.href}
            aria-label={footerItems.branding.logo.alt}
          >
            <img
              src={footerItems.branding.logo.src}
              alt={footerItems.branding.logo.alt}
              width={footerItems.branding.logo.width}
            />
          </a>
        </div>
        <div class="text-sm text-gray-600">
          {@html footerItems.branding.byline}
        </div>
        <div class="text-sm text-gray-600">
          {@html footerItems.branding.copyright}
        </div>
      </div>

      <!-- Dynamic blocks -->
      {#each footerItems.blocks as block}
        <div class="sm:col-span-6 md:col-span-3 lg:col-span-2 space-y-9">
          <h3 class="text-sm font-medium">{block.title}</h3>
          <ul class="text-sm space-y-3">
            {#each block.links as link}
              <li>
                <a
                  class="text-gray-600 hover:text-gray-900 transition"
                  href={link.href}
                  aria-label={link.ariaLabel || link.name}
                  rel="external"
                  onclick={link.isAffiliateLink ? (e) => {
                    e.preventDefault();
                    toggleAffiliatePopup();
                  } : null}
                >
                  {link.name}
                </a>
              </li>
            {/each}
          </ul>
        </div>
      {/each}
    </div>
  </div>

  <div class="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50" class:hidden={!isAffiliatePopupOpen}>
    <div class="bg-white p-8 rounded-lg shadow-lg relative max-w-6xl w-full max-h-[80vh] overflow-y-auto" bind:this={popupContainer}>
      <button 
        class="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
        onclick={toggleAffiliatePopup}
        aria-label="Close popup"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
      
      <div id="refgrow" data-project-id="125">
        <div class="flex justify-center items-center h-40">
          <LoadingSpinner class="!w-10 !h-10" />
        </div>
      </div>
    </div>
  </div>
</footer>
